import type { AxiosRequestConfig } from "axios";
import axios from "axios";
import type { UUID } from "@/Shared/types";
import { CustomsDocsUploadMode } from "@/Apis/CustomsDocsUploadMode";

export class CustomsDocsApi {
  baseUrl: string;
  accessToken: string;

  constructor(baseUrl: string, accessToken: string) {
    this.baseUrl = baseUrl;
    this.accessToken = accessToken;
  }

  async upload(
    shipmentId: UUID,
    mode: CustomsDocsUploadMode,
    files: Array<File>,
  ): Promise<void> {
    const options: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${this.accessToken}`,
        "Content-Type": "multipart/form-data",
      },

      // CS: Mar 2024, we had some issues with large files and timeouts after
      // what appeared to be 30 seconds, so increasing timeout to 2 minutes
      timeout: 120000,
    };

    const formData = new FormData();
    files.forEach(function (file, index) {
      formData.append(`file${index}`, file, file.name);
    });

    await axios.post(
      `${this.baseUrl}/customs-docs/upload?shipmentId=${shipmentId}&mode=${mode}`,
      formData,
      options,
    );
  }

  async uploadWithTrackingId(
    trackingId: UUID,
    mode: CustomsDocsUploadMode,
    files: Array<File>,
  ): Promise<void> {
    const options = {
      headers: {
        Authorization: `Bearer ${this.accessToken}`,
        "Content-Type": "multipart/form-data",
      },
    };

    const formData = new FormData();
    files.forEach(function (file, index) {
      formData.append(`file${index}`, file, file.name);
    });

    await axios.post(
      `${this.baseUrl}/customs-docs/upload-with-tracking-id?trackingId=${trackingId}&mode=${mode}`,
      formData,
      options,
    );
  }
}
